import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import RecipeList from "../recipes/RecipeList";

function HomePage({
  recipes,
  reganAndRaeFavorites,
  fetchRecipes,
  recipeOptions,
}) {
  const [selectedOption, setOption] = useState("all");

  useEffect(() => {
    fetchRecipes(selectedOption);
  }, [selectedOption]);

  const RecipeTypeSelector = ({ opt, recipeOpts }) => {
    return (
      <div style={{ width: "85%" }}>
        <select
          className="recipeStyleSelector"
          onChange={(e) => setOption(e.target.value)}
          value={opt}
        >
          {recipeOpts.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    );
  };
  return (
    <div className="jumbotron">
      <div className="recipes">
        <div className="userSelection">
          <RecipeTypeSelector opt={selectedOption} recipeOpts={recipeOptions} />
        </div>
        <RecipeList recipes={recipes} favorites={reganAndRaeFavorites} />
      </div>
    </div>
  );
}

HomePage.propTypes = {
  recipes: PropTypes.array.isRequired,
  reganAndRaeFavorites: PropTypes.array,
};

export default HomePage;
